import styled from "@emotion/styled";
import { MOBILE_QUERY_MAX_WIDTH, TABLET_QUERY_MIN_WIDTH } from "constants/vp-sizes";
// 1100px is intentional — chosen as the cards-to-slider switchover so 5 tiers
// don't get cramped at narrow widths. The features-table component uses 1199px
// as its tablet bound for a different reason (the wrapper's hardcoded 1225px
// width overflows below 1199px), so the bounds intentionally differ between
// the two pricing components.
const PRICING_TABLET_MAX_WIDTH = "1100px";
const PRICING_TABLET_MIN_WIDTH = TABLET_QUERY_MIN_WIDTH;
const calcMinWidth = (cardWidth, numberOfTiers)=>`calc(${cardWidth}px * ${numberOfTiers} + 16px * ${numberOfTiers - 1})`;
const PAGE_WIDTH_1440_CARD_WIDTH = 240;
const PAGE_WIDTH_1440_CARD_WIDTH_NEW_PRICING = 300;
const PAGE_WIDTH_1920_CARD_WIDTH = 304;
const PAGE_WIDTH_2_CARDS_WIDTH = 320;
const old_calcMinWidth1440 = (isNewPricing)=>`calc(${isNewPricing ? PAGE_WIDTH_1440_CARD_WIDTH_NEW_PRICING : PAGE_WIDTH_1440_CARD_WIDTH}px * 5 + 16px * 4)`;
const old_calcMinWidth1920 = `calc(${PAGE_WIDTH_1920_CARD_WIDTH}px * 5 + 16px * 4)`;
const calcMinWidth1440 = (numberOfTiers, isNewPricing)=>{
    const baseWidth = numberOfTiers === 2 ? PAGE_WIDTH_2_CARDS_WIDTH : isNewPricing ? PAGE_WIDTH_1440_CARD_WIDTH_NEW_PRICING : PAGE_WIDTH_1440_CARD_WIDTH;
    return calcMinWidth(baseWidth, numberOfTiers);
};
const calcMinWidth1920 = (numberOfTiers)=>{
    return calcMinWidth(PAGE_WIDTH_1920_CARD_WIDTH, numberOfTiers);
};
export const StyledProductPriceAndFeaturesCards = styled.div`
  width: ${({ isNewPricing })=>{
    const baseWidth = isNewPricing ? 240 : 216;
    return `calc(${baseWidth}px * 5 + 16px * 4)`;
}};
  max-width: calc(100% - 32px);
  padding: 32px 0;
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  .seats-and-period-selection {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
  }

  .tiers {
    display: grid;
    justify-content: center;
    column-gap: 16px;
    grid-template-columns: ${({ numberOfTiers })=>`repeat(${numberOfTiers},1fr)`};
  }

  .tiers-mobile {
    display: none;
  }

  .pricing-tax-disclaimer {
    margin-top: 24px;
    margin-bottom: 64px;
    font-size: 12px;
    line-height: 1.5;
    color: #9E9EA0;
    white-space: pre-line;
    text-align: left;
  }
  &.is-homepage-pricing {
    .seats-and-period-selection {
      padding-bottom: 0px;
    }
  }

  @media only screen and (min-width: 1440px) {
    width: ${({ isNewPricing })=>old_calcMinWidth1440(isNewPricing)};

    &.is-homepage-pricing {
      width: ${({ numberOfTiers, isNewPricing })=>calcMinWidth1440(numberOfTiers, isNewPricing)};
    }
  }

  @media only screen and (min-width: 1920px) {
    width: ${old_calcMinWidth1920};

    &.is-homepage-pricing {
      width: ${({ numberOfTiers })=>calcMinWidth1920(numberOfTiers)};
    }
  }

  @media (min-width: ${PRICING_TABLET_MIN_WIDTH}) and (max-width: ${PRICING_TABLET_MAX_WIDTH}) {
    width: 100%;
    max-width: 100%;
    /* Contain the 100vw bleed below so it doesn't cause a page-level
       horizontal scrollbar on viewports that show a system scrollbar
       (Windows + most Android browsers, ~15-17px). 100vw includes
       scrollbar width but body width does not, so without this the
       .tiers row would force <html> overflow-x. */
    overflow-x: hidden;

    .seats-and-period-selection {
      padding-left: 32px;
      padding-right: 32px;
    }

    .pricing-tax-disclaimer {
      padding: 0 32px;
    }

    .tiers:not(.tiers-mobile) {
      display: flex;
      justify-content: flex-start;
      column-gap: 16px;
      width: 100vw;
      margin-left: calc(50% - 50vw);
      margin-right: calc(50% - 50vw);
      padding: 0 16px 8px;
      box-sizing: border-box;
      overflow-x: auto;
      overflow-y: visible;
      scroll-snap-type: x mandatory;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      > * {
        flex: 0 0 260px;
        scroll-snap-align: start;
      }
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    width: 100%;
    max-width: 100%;
    overflow-x: none;
    .pricing-tax-disclaimer {
      padding: 0 16px;
    }
    .tiers {
      display: none;
      &.tiers-mobile {
        display: block;
        width: 100%;
      }
    }
    .seats-and-period-selection {
      display: flex;
      row-gap: 12px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    /* Banner sits in the existing 30px container margin-top, attached to top of
       card. Pro card uses the same padding/border/margin as others — no
       compensation needed, so titles/CTAs/separators align across all cards. */
    .tiers-mobile .card-container.is-homepage-pricing.is-most-popular .most-popular {
      position: absolute;
      top: -16px;
      left: 0;
      right: 0;
    }
    /* Override the desktop popular-card margin/padding so content aligns with
       non-popular cards. Keep desktop's border-radius: 0 0 16px 16px and
       border-top: none so the banner sits flush against the card top. */
    .tiers-mobile .card-container.is-homepage-pricing.is-most-popular .card {
      margin-top: 16px;
      padding-top: 20px;
    }
    /* Prevent flex shrinkage from collapsing the title row when card content
       overflows (Pro and Enterprise have the most features). Without this,
       .tier-title-container shrinks below its declared 50px and CTAs misalign. */
    .tiers-mobile .card-container.is-homepage-pricing .tier-title-container {
      flex-shrink: 0;
    }
    /* Extra breathing room below the last feature inside the card. */
    .tiers-mobile .card-container.is-homepage-pricing .card {
      padding-bottom: 64px;
    }
  }
`;
